import { Logo } from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, BRAND_FULL, scrollToId } from "../lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#071510] text-[#F4F1EA] pt-20 pb-10 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5"><Logo light /><p className="mt-6 text-sm text-[#F4F1EA]/70 max-w-sm leading-relaxed">Health, life and long-term planning for individuals and families nationwide.</p></div>
        <div className="md:col-span-3 flex flex-col gap-3 text-sm">
          {[["Coverage", "coverage"], ["How it works", "process"], ["About", "about"], ["FAQ", "faq"], ["Get a quote", "quote"]].map(([l, id]) => (
            <button key={id} onClick={() => scrollToId(id)} data-testid={`footer-link-${id}`} className="text-left text-[#F4F1EA]/75 hover:text-[#E5A855] transition-colors">{l}</button>
          ))}
        </div>
        <div className="md:col-span-4 flex flex-col gap-3 text-sm">
          <a href={`tel:${PHONE_TEL}`} data-testid="footer-call-link" className="hover:text-[#E5A855] transition-colors">{PHONE_DISPLAY}</a>
          <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="hover:text-[#E5A855] transition-colors break-all">{EMAIL}</a>
          <p className="text-[#F4F1EA]/70">Serving clients nationwide</p>
        </div>
      </div>
      <p aria-hidden className="font-serif-d text-[22vw] md:text-[17vw] leading-[0.8] tracking-tight text-[#0F2E23] mt-16 select-none">Anchorwell</p>
      <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-4 justify-between text-xs text-[#F4F1EA]/60">
        <p>© {new Date().getFullYear()} {BRAND_FULL}. All rights reserved.</p>
        <p className="max-w-2xl">Insurance products and availability vary by state and carrier. Information on this site is general and not tax, legal or investment advice. Not affiliated with or endorsed by the federal government or Healthcare.gov.</p>
      </div>
    </div>
  </footer>
);
